import React from 'react';
import { connect } from 'react-redux';
import { Stepper, Step, StepLabel, FlatButton, FontIcon, RaisedButton } from 'material-ui';
import R from 'ramda';
import queryString from 'query-string';
import moment from 'moment';
import { publishDraft as publishDraftAction } from '../../../../../stores/contracting/dialogs/dialog-constants';
import SendContractIcon from 'material-ui/svg-icons/content/send';
const getGenitiveCase = string => {
  if (!string) return string;
  if (string.slice(-1) === 's') return `${string}'`;
  return `${string}'s`;
};
const isNilOrEmpty = R.either(R.isNil, R.isEmpty);
const TemplateProgressIndicator = ({ isADraft, errors, leftNav }) => {
  const isEditedDraft = leftNav.originFrom === 'edited';
  const isContractDraft = isEditedDraft && leftNav.draftType !== 'template';
  const activeDraft = isContractDraft || !isNilOrEmpty(leftNav.sentPartners);
  const firstStepCompleted = !isADraft || !errors.errorExist;
  const secondStepCompleted = !isADraft;
  const thirdStepCompleted = !isADraft && !R.isEmpty(leftNav.sentPartners);
  const isLocAccom = leftNav.productType === 'Accommodation';
  return (
    <Stepper>
      <Step completed>
        <StepLabel style={{ height: '32px', paddingLeft: 0 }}>
          <div style={{ width: '100%', textAlign: 'center' }}>Create Rate Template</div>
        </StepLabel>
      </Step>
      <Step completed={firstStepCompleted}>
        <StepLabel style={{ height: '32px', paddingLeft: 0 }}>
          <div style={{ width: '100%', textAlign: 'center' }}>
            Enter Rates & Required Information
          </div>
        </StepLabel>
      </Step>
      <Step completed={secondStepCompleted}>
        <StepLabel style={{ height: '32px' }}>
          <div style={{ width: '100%', textAlign: 'center' }}>Review & Finalise</div>
        </StepLabel>
      </Step>
      <Step completed={thirdStepCompleted}>
        <StepLabel style={{ height: '32px', paddingRight: 0 }}>
          <div style={{ width: '100%', textAlign: 'center' }}>
            {secondStepCompleted ? (
              <FlatButton
                data-cy="sendRatesToPartnersButton"
                icon={<SendContractIcon />}
                label={
                  Boolean(leftNav.partnersCount)
                    ? 'Send to more partners'
                    : 'Send Rates to Partners'
                }
                labelStyle={{ padding: '0 4px', fontSize: '12px' }}
                secondary
                style={{ border: '1px solid #00bcd4', marginLeft: '4px' }}
                onTouchTap={() => {
                  window.location = `${
                    process.env.NEW_SYSTEM_URL
                  }/partner-management/send-assets?${queryString.stringify({
                    go_back_to: window.location.href,
                    templateids: [leftNav.contractId],
                    message: `Please find ${getGenitiveCase(
                      leftNav.locationName === leftNav.supplierName
                        ? leftNav.locationName
                        : `${leftNav.locationName} - ${leftNav.supplierName}`,
                    )} ${moment(leftNav.startDate).utc().format('DD MMM YYYY')} - ${moment(
                      leftNav.endDate,
                    )
                      .utc()
                      .format(
                        'DD MMM YYYY',
                      )} rates below. We are using TourConnect as they provide several standardised download formats that should make it easy for you to read and load our rates.\n\nIf you have any questions please let me know and thank you for your support.`,
                    subject: `${getGenitiveCase(
                      leftNav.locationName === leftNav.supplierName
                        ? leftNav.locationName
                        : `${leftNav.locationName} - ${leftNav.supplierName}`,
                    )} ${moment(
                      leftNav.startDate,
                    )
                      .utc()
                      .get('year')}-${moment(leftNav.endDate).utc().get('year')} Rates`,
                  })}&jwt=${localStorage.getItem('jwt')}`;
                }}
              />
            ) : (
              'Send Rates to Partners'
            )}
          </div>
        </StepLabel>
      </Step>
    </Stepper>
  );
};
TemplateProgressIndicator.contextTypes = {
  router: React.PropTypes.object.isRequired,
};
const mapStateToProps = ({ contracting }) => ({
  errors: contracting.contractActivitiesProducts.toJS().draftErrors,
});
import { push } from 'react-router-redux';
const mapDispatchToProps = dispatch => ({
  publishDraft: (...args) => dispatch(publishDraftAction(...args)),
  routerPush: (...args) => dispatch(push(...args)),
});
export default connect(mapStateToProps, mapDispatchToProps)(TemplateProgressIndicator);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/draftNTemplate-container/progressIndicatorBar/template.jsx